export const WORKFLOW_FORM_SUBMISSIONS_EXPORT_XLSX_TIMEOUT = 60 * 1000 * 3; //3 mins

export const WORKFLOW_FORM_SUBMISSIONS_EXPORT_PDF_TIMEOUT = 60 * 1000 * 1; //1 min
